export default function GS_Move_Cells() {
  return (
    <div className="p-4">
      <h1>GS Move Cells</h1>
    </div>
  );
}
